module.exports = __webpack_public_path__ + "static/img/icon.c7869ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store_files/images/hollo/icon.png
// module id = ZhYF
// module chunks = 0